let valid = 0;

setTimeout(function () {
  const captcha = document.querySelector("#g-recaptcha-response").value;

  jxAction(
    "verify_captcha",
    {
      captcha,
    },
    function (data) {
      valid = data.response.status;
    }
  );
}, 3000);

const $sendBtn = document.querySelector("#send");

$sendBtn.addEventListener("click", function (e) {
  e.preventDefault();
  const $this = e.target;

  $this.disabled = true;
  $this.textContent = "Sending...";

  const form = document.querySelector(".about-form");
  const type = form.querySelector(".type-feedback").value;
  const firstName = form.querySelector(".firstname").value;
  const lastName = form.querySelector(".lastname").value;
  const email = form.querySelector(".email").value;
  const message = form.querySelector(".message").value;

  const errorMessage = form.querySelector(".error-message");
  const errorInputs = form.querySelector(".error");

  jxAction(
    "send_feedback_about",
    {
      type,
      first_name: firstName,
      last_name: lastName,
      email,
      message,
      valid,
    },
    function (data) {
      if (errorInputs) {
        errorInputs.classList.remove("error");
      }

      if (data.response.status === 3) {
        errorMessage.textContent = data.response.fields[0].message;
        errorMessage.style.display = "block";
        data.response.fields.forEach(function (value) {
          form.querySelector(`.${value.field}`).classList.add("error");
        });
      } else if (data.response.status === 2) {
        errorMessage.textContent = data.response.message;
        errorMessage.style.display = "block";
        form.querySelector(".email").classList.add("error");
      } else if (data.response.status === 1) {
        form.querySelector(".firstname").value = "";
        form.querySelector(".lastname").value = "";
        form.querySelector(".email").value = "";
        form.querySelector(".message").value = "";

        form.querySelector(".form-fields").style.display = "none";
        form.querySelector(".thank-you").style.display = "block";
      }

      $this.disabled = false;
      $this.textContent = "Send Message";
    }
  );
});
